import React from "react";
import { Typography, useTheme } from "@material-ui/core";

import { DASHBOARD_CARD_SMALL } from "../../../../util/Constants";
import { useStyles } from "../items/HomeCardStyles";

export default function CircleKpi({ data, cardSize }) {
  const classes = useStyles({ indColor: data?.color, cardSize });
  const muiTheme = useTheme();

  return (
    <div className={classes.indCircleLabelCont}>
      <div className={classes.indCircle}>
        <Typography
          variant={DASHBOARD_CARD_SMALL !== cardSize ? "h5" : "body1"}
          className={classes.typoValue}
        >
          {data?.valor}
        </Typography>
      </div>
      {data?.label_valor && DASHBOARD_CARD_SMALL !== cardSize && (
        <>
          {data.label_valor.length > 8 ? (
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 500 100"
              preserveAspectRatio="xMinYMid meet"
              style={{
                marginTop: 5,
                marginLeft: 10,
              }}
            >
              <text
                x="0"
                y="75"
                fontSize="75"
                fill={muiTheme.palette.text.primary}
              >
                {data?.label_valor}
              </text>
            </svg>
          ) : (
            <Typography variant="subtitle1" className={classes.labelValue}>
              {data?.label_valor}
            </Typography>
          )}
        </>
      )}
    </div>
  );
}
